import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import '../css/BlendedAPY.css'

const BlendedAPY = ({ val }) => {
  return (
    <div className="blended-apy">
      <label className="blended-label">
        APY for Account Balance
        <br />
        <h1>
          <NumberFormat
            className="blended-value"
            suffix={'%'}
            value={val}
            displayType={'text'}
          />
        </h1>
      </label>
    </div>
  )
}

BlendedAPY.propTypes = {
  blendedAPY: PropTypes.number,
}

export default BlendedAPY



// WEBPACK FOOTER //
// ./src/components/BlendedAPY.js